import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'app-product-detail',
    templateUrl: './product-detail.component.html',
    styleUrls: ['./product-detail.component.scss']
})
export class ProductDetailComponent implements OnInit {

    @Input() product: any = [];
    @Output() incrementCartItem = new EventEmitter<any>();
    @Output() decrementCartItem = new EventEmitter<any>();

    constructor() {
    }

    ngOnInit() {
       
    }

    incrementQtyToCart() {
        this.incrementCartItem.emit();
    }

    decrementQtyFromCart() {
        this.decrementCartItem.emit();
    }

}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/shared/components/product-detail/product-detail.component.ts